import Base, {
  axios,
  setPromise,
  getEndpoint,
} from './base'

export {
  APIURI,
  client_secret,
  client_id,
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  endpoints,
  services,
  handlePromise,
  promise,
  setPromise,
  getEndpoint
} from './base'

const KEY = 'user.loyaltyProgram'
const PATH = '/customer/user/loyalty-program'

const myServices = {}

export const history = myServices.create = async (payload, options = {}) => {
  const endPoint = getEndpoint(`${KEY}.history`, {}, `${PATH}/history`, options)
  const {data = {}} = await axios.get(endPoint, {params: payload})
  return data
}
setPromise(`${KEY}.history`, history)

export default {
  ...Base,
  ...myServices
}
